import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms16x/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hrms16x/labels')
  },
  getIndex (searchParams) {
    let sendParams = {}
    let dteyreap = ''
    let numtime = ''
    if (typeof searchParams !== 'undefined') {
      if (isMock) return generator(mocker.index())
      dteyreap = (typeof searchParams.year !== 'undefined' ? searchParams.year : '')
      numtime = (typeof searchParams.numtime !== 'undefined' ? searchParams.numtime : '')
      sendParams = {
        p_codcomp: (typeof searchParams.codcomp !== 'undefined' ? searchParams.codcomp : ''),
        p_codpos: (typeof searchParams.codpos !== 'undefined' ? searchParams.codpos : ''),
        p_codempid_query: (typeof searchParams.codempid3 !== 'undefined' ? searchParams.codempid3 : ''),
        p_dtest: '01/01/2017',
        p_dteen: '01/08/2017'
      }
    } else {
      return generator({
        total: 0,
        rows: []
      })
    }
    return instance().get(endpoint + '/hrms16x/index/' + dteyreap + '/' + numtime, { params: sendParams })
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms16x/index.js